export default function Intro() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
          Built to the Highest Standards
        </h2>
        <p className="text-gray-600 text-base leading-relaxed mb-5">
          Every Pop Pro Tent is backed by rigorous structural engineering analysis, independent fire testing, and professional-grade rigging
          specifications. Whether you are hosting a backyard wedding or producing a major festival requiring permitting, our documentation
          gives venue owners, fire marshals, and event planners the confidence they need to approve your installation.
        </p>
        <p className="text-gray-500 text-sm leading-relaxed">
          Below you will find downloadable wind load calculations, fire certificate documentation, and complete engineered rigging specs for
          our entire product range. Each document is produced by licensed structural engineers and accredited testing laboratories.
        </p>
      </div>
    </section>
  );
}